import { useEffect, useContext } from 'react'

// ctx
import { StatsDataContext, StatsDispatchContext } from 'src/store/stats/Store'
import { SaveDataContext, SaveDispatchContext } from 'src/store/save/Store'

// actions
import {
  rest,
  levelUp
} from 'src/store/stats/actions'

import {
  setSwitch,
  setCounter
} from 'src/store/save/actions'

const useResting = () => {
  // for levelup etc
  const { stats } = useContext(StatsDataContext)
  const { dispatchStats } = useContext(StatsDispatchContext)
  const { save } = useContext(SaveDataContext)
  const { dispatchSave } = useContext(SaveDispatchContext)

  // checks for and processes resting events
  useEffect(() => {
    if (save.switches.is_resting) {
      rest(dispatchStats, stats)
      setCounter(dispatchSave, 'day', {'+': 1})
      setSwitch(dispatchSave, 'is_resting', false)
      setSwitch(dispatchSave, 'is_levelling_up', true)
    }
  }, [save.switches.is_resting])

  // checks for and processes levelling events
  useEffect(() => {
    if (save.switches.is_levelling_up) {
      levelUp(dispatchStats, stats)
      setSwitch(dispatchSave, 'is_levelling_up', false)
    }
  }, [save.switches.is_levelling_up])
}

export default useResting
